import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/UI/LoadingSpinner';

const DemoLogin: React.FC = () => {
  const { loginDemo } = useAuth();
  const [error, setError] = useState<string>('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await loginDemo();
      } catch (e: any) {
        if (!cancelled) setError(e?.message || 'Demo login failed');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [loginDemo]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-emerald-900 to-slate-900 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="card py-8 px-6 sm:px-10">
          <h1 className="text-xl font-bold text-gray-900">Opening demo…</h1>
          <p className="mt-2 text-sm text-gray-600">
            We’re signing you in to a read-only demo farm.
          </p>

          {error ? (
            <div className="mt-6">
              <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
                <p className="text-sm text-red-800">{error}</p>
              </div>
              <Link to="/auth" className="text-sm font-medium text-amber-700 hover:text-amber-800">
                Go to login
              </Link>
            </div>
          ) : (
            <div className="mt-6 flex items-center gap-3">
              <LoadingSpinner size="sm" />
              <span className="text-sm text-gray-700">Please wait…</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DemoLogin;

